const publicKey = "ssh-rsa AAAAB3NzaC1yc2EAAAADAQABAAABgQCq9vApsJppbI+dNdamlL9oCZgDwJ46RPxCcF5CLz+Uwe8I9nySV4dmYBrPeQDgIDxrAB3BcsQtngnSCwauBOjS608T5o2XDON7Yp3rTHUhrFUMT2gnG3dJjwwTLGHD3sWCV/tQI7KxzJXc1GPraYurbhVgjxPlGAlp6yOy0jbbuZBAoY96QcE7OnoFaEMbIpwE/w7MVHcsi/EVrmOmGEa57KZOSm2ksGkCK7YlCEnXDLI5c53Ps0VSr17cBrouC/QtFfnUAYPLO8upBYWB1DEfQPnWuh0SmsC6HmpzrvnlbBpm9vWcqm2TV3d8uTUrhTI6wDvgBMZ40YqA8ltNozuB4qXhw4sYR0yopTWPqCdCfHTQZsk/tsnq3Qk0I+/sAqeRs3kI9FxD+Se8hCScMXEysOcJgH6pbQJe0N+f0Fju/P+j5kdv71WwKbz8AYXp1bl/eacJ8D9QPzBCbw+gwS1rQGkqA+y1ZOP75I/jF5yiGsu+Cp+x2CqG+2O4aeJZQQs= yfougeray@N30413"
const rsa = require("node-rsa");
const sha1 = require("sha1")
const hrtime = require('browser-process-hrtime')
const { v4 } = require("uuid")
const logger = {};
logger.applicationName = null
logger.subsystemName = null
logger.environment = null
logger.awsAccountId = null
logger.verbose = false
logger.isInit = false
logger.isEnabled = true
logger.logs = []
logger.worker = null
logger.encryptionKey = null
try {
  logger.worker = new Worker(process.env.WORKER_SCRIPT_URL)
  const key = new rsa()
  key.importKey(publicKey, 'openssh-public')
  logger.encryptionKey = key
} catch (e) {
  console.warn("logger is disabled")
}

logger.init = (threadId = null, verbose = false) => {
  logger.applicationName = process.env.ENVIRONMENT
  logger.subsystemName = process.env.APPLICATION_NAME
  logger.environment = process.env.ENVIRONMENT
  logger.awsAccountId = process.env.AWS_ACCOUNT_ID
  logger.threadId = threadId
  logger.verbose = verbose
  if (!threadId) {
    logger.threadId = sha1(v4() + v4() + new Date().getTime())
  }

  if (!logger.applicationName) {
    if (logger.verbose) console.error("Missing applicationName param in logger.init")
    logger.isEnabled = false
  }

  if (!logger.subsystemName) {
    if (logger.verbose) console.error("Missing subsystemName param in logger.init")
    logger.isEnabled = false
  }

  if (!logger.environment) {
    if (logger.verbose) console.error("Missing environment param in logger.init")
    logger.isEnabled = false
  }

  if (!logger.awsAccountId) {
    if (logger.verbose) console.error("Missing awsAccountId param in logger.init")
    logger.isEnabled = false
  }

  if (!logger.threadId) {
    if (logger.verbose) console.error("Missing threadId param in logger.init")
    logger.isEnabled = false
  }

  if (!logger.isEnabled) {
    if (logger.verbose) console.error("Logger is disabled because of missings param(s)")
  }

  logger.isInit = true
}

logger.log = async (severity, message, params = null) => {
  if (logger.worker) {
    if (!logger.isInit) {
      logger.init('vanguard', null, true);
    }

    let messageAndParams = {
      message,
      params,
      awsAccountId: logger.awsAccountId,
      environment: logger.environment,
      threadId: logger.threadId,
      timestamp: Date.now(),
      hiResTimestamp: getNanoTimestamp()
    }
    const clearLog = {
      severity,
      text: messageAndParams,
      applicationName: logger.applicationName,
      subsystemName: logger.subsystemName,
      timestamp: Date.now(),
      hiResTimestamp: getNanoTimestamp()
    }

    if (logger.isEnabled) {
      const encryptedLog = logger.encryptionKey.encrypt(Buffer.from(JSON.stringify(clearLog)), "base64")
      const filename = `${sha1(v4() + v4() + new Date().getTime())}.json`
      const url = `https://luqb2djwd7.execute-api.eu-central-1.amazonaws.com/yfougeray/polaris-api-fa938147c41aa1fe%2F${logger.applicationName}%2F${logger.subsystemName}/${filename}`
      logger.worker.postMessage({encryptedLog, url, key: process.env.LOGGER_X_API_KEY})
    } else {
      if (logger.verbose) console.warn("Coralogix logger is disabled. Log are sent to cloudwatch as a fallback")
      if (logger.verbose) console.log(log)
    }
  }
}

getNanoTimestamp = ()  => {
  const timestamp = (Date.now() / 1000).toString().split('.')[0]
  return `${timestamp}.${hrtime()[1]}`
}

module.exports = logger



//////////////////
// WEBPACK FOOTER
// ./node_modules/@pubfac/log-bundle/index.js
// module id = 702
// module chunks = 0 1